export function generateTrackingKey(context: string, event: string): string {
	return `${context}.${event}`;
}
